<!--
 * @Autor: zouning@szkingdom.com
 * @Date: 2024-05-16 19:26:55
 * @Description: 
 * @LastEditors: zouning@szkingdom.com
-->
<template>
    <div id="app">
        <router-view :key="$route.name" />
        <vue-progress-bar />
    </div>
</template>
<script>
export default {
    name: "App",
    data() {
        return {};
    },
    computed: {
        customerServiceSrc() {
            return (
                this.$cache.getParamValue("customer_service") &&
                this.$cache.getParamValue("customer_service").onlineurl
            );
        }
    },
    watch: {
        customerServiceSrc: {
            immediate: true,
            handler() {
                this.loadCustomerService();
            }
        }
    },
    methods: {
        loadCustomerService() {
            const src = this.customerServiceSrc;
            console.log(src);
            if (!src) return;
            const exist = document.getElementById("customer-service");
            if (exist) {
                if (exist.getAttribute("src") === src) return;
                exist.parentNode && exist.parentNode.removeChild(exist);
            }
            const s = document.createElement("script");
            s.id = "customer-service";
            s.src = src;
            s.charset = "utf-8";
            document.body.appendChild(s);
        }
    }
};
</script>
